import { render, staticRenderFns } from "./SpyderAnnualUpsell.vue?vue&type=template&id=8d3fe7ae"
import script from "./SpyderAnnualUpsell.vue?vue&type=script&lang=js"
export * from "./SpyderAnnualUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports